import { render, staticRenderFns } from "./MdSpecialPrecautions.vue?vue&type=template&id=188b04fe&"
import script from "./MdSpecialPrecautions.vue?vue&type=script&lang=js&"
export * from "./MdSpecialPrecautions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports